// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"84":"common-ui","744":"actioncable"}[chunkId] + "-" + {"84":"976bfd94d9eee139802d","744":"bfacd38bb0a1da87a076"}[chunkId] + ".chunk.js";
};